import React, {useState, forwardRef, useImperativeHandle, useEffect} from 'react';
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap";


// components
import ActivityLangs from "./_activityLangs";
import { getStateByPath } from "../../../../redux/selectors";
import { GenericButton } from "../../../../components/buttons/customButtons";
import CustomFormTitle from '../../../../components/genericComponents/CustomFormTitle';

// labels
import { INTERNATIONAL } from "../../../../components/i18n/i18n";
import { FL_ORDER } from "../../../../components/i18n/formLabels";
import { TT_CLOSE, TT_SAVE } from "../../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// service
import {activityService} from "../../../../jwt/_services/core/activityService";
import Loading from "../../../../components/loader/Loading";



const ActivityForm = forwardRef((props, ref) => {
    const { activitiesPath, mainPath, categoriesPath } = props

    const udnState = useSelector(state => getStateByPath(state, mainPath));
    const categoriesState = useSelector(state => getStateByPath(state, categoriesPath));
    const activityState = useSelector(state => getStateByPath(state, activitiesPath));

    const { app:{ fbDataBase }, domainObject:udn } = udnState?.data || {};
    const { domainObject:category } = categoriesState?.data || {};
    const { domainObject: activity, editMode } = activityState?.data || {};


    const [modal, setModal] = useState(false);
    const [status, setStatus] = useState( activity?.status || true);
    const [langs, setLangs] = useState(activity?.langs || []);
    const [loading, setLoading] = useState(false);

    const translatableLangs = activity?.translatedLangs || [];


    useImperativeHandle(ref, () => ({
        showModal: () => {
            setModal(true);
        }
    }));




    const validationSchema = Yup.object().shape({});


    // Initialize the form using the useForm hook from react-hook-form.
    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: activity?.id,
            showOrder: activity?.showOrder,
            image: activity?.image,
        }
    });





// Reinicia el formulario cuando cambie la actividad
    useEffect(() => {
        reset({
            id: activity?.id,
            showOrder: activity?.showOrder,
            image: activity?.image,
        });

        setLangs(activity?.langs || []);
    }, [activity, reset]);









    const onSubmit = async (data, _) => {
        const requestData = {
            fbDataBase: { id: fbDataBase?.id },
            item: {
                data,
                langs,
                status,
                category: { id: category?.id },
                udn: { id: udn?.id }
            }
        }

        setLoading(true);

        if(editMode) {
            requestData.item.id = activity?.id;
            genericIndexedActions.update(activitiesPath, activityService, activity?.id, requestData, closeForm)
        }
        else
            genericIndexedActions.save(activitiesPath, activityService, requestData, closeForm)
    }





    const closeForm = () => {
        setLoading(false);
        setModal(false);
    }







    return <Modal isOpen={modal} toggle={setModal} modalClassName="menu-modal-form-medium">
        <Loading isLoading={loading} showTitle={false} />
        <Form  data-form="activity" className="activity-form"  onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom">
                    <CustomFormTitle domainObject={activity} />

                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            toolTip={TT_SAVE}
                            icon={'fa-save'}
                            permission={'add'}
                            type={'submit'}
                        />
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>

                <CardBody>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label >{ FL_ORDER }</Label>
                                <Input
                                    type="number"
                                    name="showOrder"
                                    placeholder="Orden Visualización"
                                    innerRef={register}
                                    className={(errors.showOrder ? ' is-invalid' : '')}
                                />
                                { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label >Activo</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={_ => setStatus( !status )}
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label >Imagen</Label>
                                <Input
                                    type="text"
                                    name="image"
                                    innerRef={register}
                                    className={(errors.image ? ' is-invalid' : '')}
                                />
                                { errors.image && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.image?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <br/>
                    <br/>

                    <Row>
                        <Col>
                            <h2>{INTERNATIONAL}</h2>
                            <br/>
                            <ActivityLangs
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Form>
    </Modal>
})

export default ActivityForm;